import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import(/* webpackChunkName: "home" */ "../views/Home.vue")
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () =>
      import(/* webpackChunkName: "dashboard" */ "../views/Dashboard.vue")
  },
  {
    path: "/insights",
    name: "Insights",
    component: () =>
      import(/* webpackChunkName: "insights" */ "../views/Insights.vue")
  },
  {
    path: "/login",
    name: "Login",
    redirect: "/"
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: "/invite/:key",
    name: "Register",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/Register.vue")
  },
  {
    path: "/settings",
    name: "Settings",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "settings" */ "../views/Settings.vue")
  },
  {
    path: "/gallery",
    redirect: "/gallery/1",
    name: "Gallery"
  },
  {
    path: "/gallery/:page",
    name: "Gallery",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "gallery" */ "../views/Gallery.vue")
  },
  {
    path: "/register",
    name: "Register",
    redirect: "/invite"
  },
  {
    path: "/starred",
    redirect: "/starred/1",
    name: "Starred"
  },
  {
    path: "/starred/:page",
    name: "Starred",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "starred" */ "../views/Starred.vue")
  },
  {
    path: "/changelog",
    name: "Changelog",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "changelog" */ "../views/Changelog.vue")
  },
  {
    path: "/api/v1/changelog/downgrade/:id",
    name: "Downgrade",
    redirect: "/changelog"
  },
  {
    path: "/autoCollect",
    name: "AutoCollect",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "autoCollect" */ "../views/AutoCollect.vue")
  },
  {
    path: "/autoCollect/settings",
    name: "AutoCollect Settings",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "autoCollectSettings" */ "../views/AutoCollectSettings.vue"
      )
  },
  {
    path: "/autoCollect/:id",
    name: "AutoCollect Item",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "autoCollectItem" */ "../views/AutoCollectItem.vue"
      )
  },
  {
    path: "/admin",
    name: "Admin",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "admin" */ "../views/Admin.vue")
  },
  {
    path: "/domains",
    name: "Domains",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "domains" */ "../views/Domains.vue")
  },
  {
    path: "/u/:user",
    name: "User",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "user" */ "../views/UserV2/UserWrapper.vue")
  },
  {
    path: "/domains/donate",
    name: "Donate a Domain",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "domainsDonate" */ "../views/DomainsDonate.vue"
      )
  },
  {
    path: "/domains/manage/:domain",
    name: "Domain Management",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "domainsManagement" */ "../views/DomainsManage.vue"
      )
  },
  {
    path: "/legal/terms",
    name: "Terms of Service",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "legalTerms" */ "../views/LegalTerms.vue")
  },
  {
    path: "/legal/privacy",
    name: "Privacy Policy",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "legalPrivacy" */ "../views/LegalPrivacy.vue")
  },
  {
    path: "/collections/:type/:token",
    name: "Collection Share",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "collections" */ "../views/CollectionsItem.vue"
      )
  },
  {
    path: "/collections/:id",
    name: "Collection",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "collections" */ "../views/CollectionsItem.vue"
      )
  },
  {
    path: "/collections",
    name: "Collections",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "collections" */ "../views/Collections.vue")
  },
  {
    path: "/users",
    name: "Users",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "users" */ "../views/Users.vue")
  },
  {
    path: "/discordAuthorize/:type",
    name: "Discord Authorization",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "discordAuthorize" */ "../views/DiscordAuthorize"
      )
  },
  {
    path: "/plans",
    name: "Plans",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "plansBilling" */ "../views/Plans")
  },
  {
    path: "/moderation",
    name: "Moderation",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "moderation" */ "../views/Moderation.vue")
  },
  {
    path: "/passwordReset/sent",
    name: "Password Reset Sent",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "passwordResetSent" */ "../views/PasswordResetSent.vue"
      )
  },
  {
    path: "/passwordReset/confirm/:code",
    name: "Password Reset",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "passwordResetConfirm" */ "../views/PasswordResetConfirm.vue"
      )
  },
  {
    path: "/pages",
    name: "Pages",
    redirect: "/settings"
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "page" */ '../views/BioSettings.vue')
  },
  {
    path: "/p/:username",
    name: "Bio",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "pageItem" */ "../views/Bio.vue")
  },
  {
    path: "/browser",
    name: "File Browser",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "browser" */ "../views/Browser.vue")
  },
  {
    path: "/flowinityAuthorize/:type",
    name: "Flowinity Authorize",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "flowinityAuthorize" */ "../views/FlowinityAuthorize.vue"
      )
  },
  {
    path: "/slideshow/:code",
    name: "Slideshow",
    component: () =>
      import(/* webpackChunkName: "slideshow" */ "../views/Slideshow.vue")
  },
  {
    path: "/pastes",
    name: "Pastes",
    redirect: "/gallery",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "pastes" */ "../views/Pastes.vue")
  },
  {
    path: "/pastes/create",
    name: "Create a Paste",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "pastesCreate" */ "../views/PastesCreate.vue")
  },
  {
    path: "/experiments",
    name: "Experiments",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "experiments" */ "../views/Experiments.vue")
  },
  {
    path: "/:item",
    name: "Attachment",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "item" */ "../views/Item.vue")
  },
  {
    path: "/*/:item",
    name: "Attachment",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "item" */ "../views/Item.vue")
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
})

export default router
